import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { referentiels, dossiers as apiDossiers } from './services/api';

// Contexte global : l'utilisateur connecté, les référentiels (catégories,
// sociétés, barème km) et les dossiers de mission personnels.
const NdfContext = createContext(null);

export function NdfProvider({ user, children }) {
  const [refs, setRefs] = useState({ categories: [], societes: [], bareme: [] });
  const [dossiers, setDossiers] = useState([]);

  const recharger = useCallback(() => {
    referentiels.charger().then((res) => setRefs(res.data)).catch(() => {});
  }, []);
  const rechargerDossiers = useCallback(() => {
    apiDossiers.liste().then((res) => setDossiers(res.data.dossiers)).catch(() => {});
  }, []);

  useEffect(() => { recharger(); rechargerDossiers(); }, [recharger, rechargerDossiers]);

  return (
    <NdfContext.Provider value={{ user, refs, recharger, dossiers, rechargerDossiers }}>
      {children}
    </NdfContext.Provider>
  );
}

export function useNdf() {
  return useContext(NdfContext);
}
